export const ru = {
    'exclude-phrases': 'Исключить фразы с нулевыми показами'
};
